import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-04b37635"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "accumulated-goal-container" }
const _hoisted_2 = {
  key: 1,
  class: "chart-group-legends"
}
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<div class=\"chart-legends\" data-v-04b37635><h6 style=\"margin-right:auto;\" data-v-04b37635>Acumulado x Meta</h6><span class=\"chart-legends-meta\" data-v-04b37635></span><p class=\"chart-legends-text\" data-v-04b37635>Meta acumulada</p><span class=\"chart-legends-projetado\" data-v-04b37635></span><p class=\"chart-legends-text\" data-v-04b37635>Projetado acumulado</p><span class=\"chart-legends-realizado\" data-v-04b37635></span><p class=\"chart-legends-text\" data-v-04b37635>Realizado Acumulado</p></div>", 1)
const _hoisted_4 = [
  _hoisted_3
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Overlay = _resolveComponent("Overlay")!
  const _component_VChart = _resolveComponent("VChart")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.loading)
      ? (_openBlock(), _createBlock(_component_Overlay, { key: 0 }))
      : _createCommentVNode("", true),
    (!_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_4))
      : _createCommentVNode("", true),
    (!_ctx.loading)
      ? (_openBlock(), _createBlock(_component_VChart, {
          key: 2,
          id: "billed-chart",
          class: "chart",
          option: _ctx.options,
          autoresize: ""
        }, null, 8, ["option"]))
      : _createCommentVNode("", true)
  ]))
}